import { POSTAPI, generateHeader } from "../../../api-setup/api-helper";
import { GET_ALL_CONTRACT_DETAILS, GET_CONTRACT_FOR_PROVIDER } from "../../../api-setup/api-endpoints";
import { capitalize } from "./capitalize";
import { formatUnitLabel } from "../../../utils/payRequestUtils";
import { convertToDecimals, GridColumnDataMapper } from "../../../utils/utils";

export const fetchAllContractDetails = async (
  cookiesData,
  dispatch,
  pageOffset = 0,
  pageRows = 500,
  filter = null,
  sortColumn = "ct.contract_mstr_key",
  sortOrder = "ASC",
  exportFlag = 0,
  hospitalFilter = null,
  specialtyFilter = null,
  contractTypeFilter = null,
  contractNameFilter = null,
  npiFilter = null,
  positionFilter = null
) => {
  try {
    const apiHeaders = generateHeader();

    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_user_id: cookiesData.out_user_id,
      in_sort_column: sortColumn,
      in_sort_order: sortOrder,
      in_filter: filter,
      in_page_row_offset: pageOffset,
      in_page_rows: pageRows,
      in_export_flag: exportFlag,
      in_hospital_filter: hospitalFilter,
      in_specialty_filter: specialtyFilter,
      in_contract_type_filter: contractTypeFilter,
      in_contract_name_filter: contractNameFilter,
      in_npi_filter: npiFilter,
      in_position_filter: positionFilter,
      in_is_contract_management: 1,
    };

    const response = await POSTAPI(false, GET_ALL_CONTRACT_DETAILS, null, apiHeaders, requestBody, dispatch);

    if (response?.data?.row_result && Array.isArray(response.data.row_result)) {
      // Transform the data to match the expected format for the grid
      const transformedData = response.data.row_result.map((item, index) => ({
        ...item,
        id: `${item.contract_mstr_key}-${index}`,
        providerId: item.provider_id,
        thresold_unit_type: formatUnitLabel(item.thresold_unit_type),
        rate_type: capitalize(item.rate_type),
        rate_unit_type: formatUnitLabel(item.rate_unit_type),
        rate: item.rate != null ? convertToDecimals(item.rate, 4) : null,
        period_type: capitalize(item.period_type),
      }));

      let columData = [];
      if (response.data.out_parameters?.out_columns_xml) {
        columData = GridColumnDataMapper(response.data.out_parameters.out_columns_xml, "", true);
      }

      return {
        success: true,
        data: transformedData,
        columData,
        totalRows: response.data.out_parameters.out_total_rows || transformedData.length,
        error: null,
      };
    } else {
      console.error("Failed to fetch all contract details:", response);
      return {
        success: false,
        data: [],
        columData: [],
        error: response?.data?.out_parameters?.out_error_msg || "Failed to fetch contract details",
      };
    }
  } catch (error) {
    console.error("Error in fetchAllContractDetails:", error);
    return {
      success: false,
      data: [],
      columData: [],
      error: error.message || "An error occurred while fetching contract details",
    };
  }
};

export const fetchContractForProvider = async (cookiesData, dispatch, contractMstrKey, providerId, locationMstrKey) => {
  try {
    const apiHeaders = generateHeader();

    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_provider_id: providerId,
      in_contract_mstr_key: contractMstrKey,
      in_location_mstr_key: locationMstrKey,
      in_timesheet_mstr_key: null,
      in_filter: null,
      in_sort_number: 1,
      in_sort_order: "ASC",
      in_is_contract_management: 1,
    };

    const response = await POSTAPI(false, GET_CONTRACT_FOR_PROVIDER, null, apiHeaders, requestBody, dispatch);

    if (response?.data?.row_result && Array.isArray(response.data.row_result)) {
      return {
        success: true,
        data: response.data.row_result,
        error: null,
      };
    } else {
      console.error("Failed to fetch contract for provider:", response);
      return {
        success: false,
        data: [],
        error: response?.data?.out_parameters?.out_error_msg || "Failed to fetch contract details",
      };
    }
  } catch (error) {
    console.error("Error in fetchContractForProvider:", error);
    return {
      success: false,
      data: [],
      error: error.message || "An error occurred while fetching contract details",
    };
  }
};
